// src/redux/rootReducer.ts

import { combineReducers } from '@reduxjs/toolkit';
import documentsReducer from "./api/documents/documentsSlice";
import operationsReducer from "./api/operations/operationsSlice";
import appReducer from "./api/app/appSlice";
import documentSetReducer from "./slices/documentSetSlice";
import settingsReducer from "./slices/settingsSlice";

const rootReducer = combineReducers({
    documents: documentsReducer,
    operations: operationsReducer,
    app: appReducer,
    documentSet: documentSetReducer,
    settings: settingsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
